import ApiService from '@/services/core/api.service'

const TicketCategoryService = {
  async get (query) {
    return ApiService.get(`admin/ticket-categories?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/ticket-categories', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/ticket-categories/${payload.id}`, payload)
  }
}

export default TicketCategoryService
